// Persistent light/dark theme. The initial class is set in index.html (no FOUC).
export const getTheme = () =>
  typeof document !== "undefined" && document.documentElement.classList.contains("dark") ? "dark" : "light";

export function setTheme(mode) {
  const el = document.documentElement;
  el.classList.add("theme-anim");
  if (mode === "dark") el.classList.add("dark");
  else el.classList.remove("dark");
  try { localStorage.setItem("theme", mode); } catch (e) { /* ignore */ }
  window.setTimeout(() => el.classList.remove("theme-anim"), 400);
}
